import type { AnswerWidgets } from '@openx/components-core/lib/AiChat/answerWidgets.ts';
import { getMessageId } from '@openx/components-core/lib/AiChat/messageId.ts';
import type { TroubleshootingMessage } from '@openx/components-deal/lib/DealDetails/components/DealTroubleshootingMessageActions.tsx';
import { FeedbackMessageActions } from './components/FeedbackMessageActions/FeedbackMessageActions.tsx';
import { useMessageFeedbackActions } from './hooks/useMessageFeedbackActions.ts';

type OpenXAgentFeedbackProps = {
  message: TroubleshootingMessage;
  widgets?: AnswerWidgets | undefined;
};

export const OpenXAgentFeedback = ({ message, widgets }: OpenXAgentFeedbackProps) => {
  const {
    actionsState,
    submittingMessageId,
    handleThumbUp,
    handleThumbDown,
    handleSubmitFeedback,
    handleCancelFeedback,
  } = useMessageFeedbackActions();

  return (
    <FeedbackMessageActions
      message={message}
      widgets={widgets}
      msgState={actionsState[getMessageId(message)]}
      isSubmitting={submittingMessageId === getMessageId(message)}
      onThumbUp={handleThumbUp}
      onThumbDown={handleThumbDown}
      onSubmitFeedback={handleSubmitFeedback}
      onCancelFeedback={handleCancelFeedback}
    />
  );
};
